export default "__VITE_ASSET__Bcp2C0LZ__"